// Card.js
import React from 'react';

function Card({reelId, symbol, reelsTextMap}) {
    const text = reelsTextMap.get(`${reelId}_${symbol}`);
    return (
        <div className="card">
            {text ? text : symbol}
        </div>
    );
}

export default Card;
